module.exports = __webpack_public_path__ + "static/media/Протокол от проведеното на 27.06.2022 г. ОСА на Формопласт АД.839fd4cf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2022/Протокол от проведеното на 27.06.2022 г. ОСА на Формопласт АД.pdf
// module id = 98
// module chunks = 0